export default __webpack_public_path__ + "static/media/img_step_lucia07-04.28d38add.png";